import React, { useState, useEffect } from 'react';

export default function useTimeChangeIconBubbleVisible(
  icon: React.RefObject<HTMLElement>,
  forceVisible?: true | undefined,
  getRoot?: () => HTMLElement | null,
  getRootMargin?: () => IntersectionObserverInit['rootMargin'],
) {
  const [iconBubbleVisible, setIconBubbleVisible] = useState<true | undefined>(forceVisible);

  useEffect(() => {
    setIconBubbleVisible(forceVisible);
  }, [forceVisible]);

  useEffect(() => {
    if (!icon.current) return;
    if (!forceVisible) return;

    const observer = new IntersectionObserver(
      (intersections) => {
        const { intersectionRatio } = intersections?.[0] || {};
        if (intersectionRatio === 0) {
          if (iconBubbleVisible) {
            setIconBubbleVisible(undefined);
          }
          return;
        }
        setIconBubbleVisible(intersectionRatio < 1 ? undefined : forceVisible);
      },
      { root: getRoot?.(), rootMargin: getRootMargin?.(), threshold: [0, 1] },
    );

    observer.observe(icon.current);

    return () => {
      observer.disconnect();
    };
  }, [forceVisible, iconBubbleVisible]);

  return iconBubbleVisible;
}
